@if(!user()) {
<av-loading-item [icon]="'person'" [textKey]="'shared.general.labels.loading'"/>
} @else {
<av-content-container>
    <div class="col-6">
        <av-card cardTitle="app.user.overview.sections.personal.title" icon="person" [fields]="personalFields()" />
    </div>

    <div class="col-6">
        <av-card cardTitle="app.user.overview.sections.organization.title" icon="business"
            [fields]="organizationFields()" />
    </div>
</av-content-container>
}